import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import obtieneDatos from './obtieneDatosCookiesUsuario'
import axios from 'axios';
import FooterCorp from '../modulos/footerCorp';
import devuelveDependenciaConstultada from './seteaDependencias';
import seteaCokie from '../tools/seteaCokie';
import devuelveEscuela from './devuelveEscuela';
import Bienvenido from './intro';
import comprueboPermisos from './comprueboPermisos';
import Notificaciones from './Notificaciones';
import './edit.css'

import LogueMovimientos from './LogueMovimientos';
import socket, { conectarSocket } from "../tools/socke";

const cookies = new Cookies();

function Main() {
  const [intro, setIntro] = useState(true);
  const [verNotificacion, setVerNotificacion] = useState(false);
  const [Usuario, setUsuario] = useState(null);
  const [cargandoUsuario, setCargandoUsuario] = useState(true);
  const [errorUsuario, setErrorUsuario] = useState("");
  const [DependenciasExistentes, setDependenciasExistentes] = useState(null);
  const [online, setOnline] = useState(false);
  const [resumenLecturas, setResumenLecturas] = useState(null);
  const [errorLecturas, setErrorLecturas] = useState("");
  const [modalLecturas, setModalLecturas] = useState(null); // "todos" | "pendientes"
  const [cargandoLecturas, setCargandoLecturas] = useState(false);

  const navitate = useNavigate();

  const {
    register,
    formState: { errors },
    watch,
    handleSubmit,
  } = useForm({});

 const logueaUsuario = async () => {
  setCargandoUsuario(true);
  setErrorUsuario("");

  const datosSesion = obtieneDatos() || {};

  // Recuperamos la identificación.
  const identificacion =
    datosSesion?.identificacion ||
    datosSesion?.dni ||
    cookies.get("identificacion") ||
    cookies.get("usuario") ||
    "";

  // Recuperamos el usuario que ya inició sesión.
  const usuarioSesion = {
    ...datosSesion,
    id: datosSesion?.id || cookies.get("id") || null,
    identificacion,
    nombre: datosSesion?.nombre || cookies.get("nombre") || "",
    apellido:
      datosSesion?.apellido ||
      cookies.get("apellidoUsuario") ||
      "",
    sedeID: datosSesion?.sedeID ?? cookies.get("sedeID"),
    destino: datosSesion?.destino ?? cookies.get("destino"),
    nivel: datosSesion?.nivel ?? cookies.get("nivel"),
    estado: datosSesion?.estado ?? cookies.get("estado"),
    funcion: datosSesion?.funcion || cookies.get("funcion") || "",
  };

  // Función para establecer la sede.
  const actualizarSede = (usuario) => {
    const sedeId = String(
      usuario?.sedeID ??
      usuario?.sedeId ??
      usuario?.sede ??
      ""
    );

    const sedes = {
      "1": "Provincial",
      "2": "Rosario",
      "3": "Recreo",
      "4": "Reconquista",
    };

    localStorage.setItem(
      "sedeUsuario",
      sedes[sedeId] || ""
    );
  };

  try {
    if (!identificacion) {
      throw new Error(
        "No se encontró la identificación del usuario logueado."
      );
    }

    const tokenJWT = localStorage.getItem("tokenJWT");

    // Consultamos los datos actualizados del usuario.
    const usuarioObtenido = await axios.post(
      `${process.env.REACT_APP_BASEURL}usuarios/${identificacion}`,
      {},
      {
        headers: tokenJWT
          ? { Authorization: `Bearer ${tokenJWT}` }
          : {},
      }
    );

    let usuarioActualizado =
      usuarioObtenido?.data?.usuario ??
      usuarioObtenido?.data?.datos ??
      usuarioObtenido?.data;

    if (Array.isArray(usuarioActualizado)) {
      usuarioActualizado = usuarioActualizado[0] || null;
    }

    if (
      !usuarioActualizado ||
      typeof usuarioActualizado !== "object" ||
      !usuarioActualizado.id
    ) {
      throw new Error(
        "El backend no devolvió un usuario válido."
      );
    }

    // Actualizamos las cookies tradicionales.
    seteaCokie(usuarioActualizado);

    // Conservamos los datos de la sesión y actualizamos
    // únicamente los campos que devolvió el servidor.
    const usuarioParaEstado = {
      ...usuarioSesion,
      ...usuarioActualizado,
    };

    actualizarSede(usuarioParaEstado);

    setUsuario(usuarioParaEstado);
    setErrorUsuario("");

    console.log(
      "✅ Usuario actualizado correctamente:",
      usuarioParaEstado.identificacion
    );

  } catch (error) {
    console.error("❌ Error actualizando usuario:", error);
    console.error("Respuesta backend:", error?.response?.data);

    const mensaje =
      error?.response?.data?.message ||
      `No se pudo actualizar el usuario (HTTP ${
        error?.response?.status || "sin respuesta"
      }).`;

    setErrorUsuario(mensaje);

    // Si la sesión local ya contiene un usuario activo,
    // permitimos mostrar el panel aunque falle la actualización.
    if (
      usuarioSesion?.id &&
      Number(usuarioSesion?.estado) === 1
    ) {
      console.warn(
        "⚠️ Se utilizarán temporalmente los datos de la sesión local."
      );

      actualizarSede(usuarioSesion);
      setUsuario(usuarioSesion);

    } else {
      console.warn(
        "⚠️ No existe una sesión local válida."
      );

      setUsuario(null);
    }

  } finally {
    setCargandoUsuario(false);
  }
};

  // ============================================================
  // AL ENTRAR AL MENÚ PRINCIPAL SIEMPRE REFRESCAMOS EL USUARIO
  // ============================================================

  useEffect(() => {
    logueaUsuario();
  }, []);

  useEffect(() => {
    devuelveDependenciaConstultada().then(f => setDependenciasExistentes(f));
  }, []);

  useEffect(() => {
    const onConnect = () => setOnline(true);
    const onDisconnect = () => setOnline(false);

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, []);

  
  // Consultar los expedientes que están actualmente en la dependencia.
  // El backend obtiene destino y sede del JWT, no de estos parámetros.
  useEffect(() => {
    if (!Usuario?.id || !Number(Usuario?.destino)) return;

    let activo = true;
    let ejecutando = false;

    const cargarResumen = async () => {
      if (ejecutando) return;
      ejecutando = true;
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BASEURL}expedientes/resumenLecturasDependencia`,
          {},
          { withCredentials: true }
        );
        if (activo) {
          setResumenLecturas(data);
          setErrorLecturas("");
        }
      } catch (error) {
        console.error("Error consultando lecturas de expedientes:", error);
        if (activo) {
          setErrorLecturas("No se pudieron consultar los expedientes");
          setResumenLecturas(null);
        }
      } finally {
        ejecutando = false;
      }
    };

    cargarResumen();
    const intervalo = setInterval(cargarResumen, 60000);
    const alVolver = () => { if (document.visibilityState === "visible") cargarResumen(); };
    document.addEventListener("visibilitychange", alVolver);
    return () => {
      activo = false;
      clearInterval(intervalo);
      document.removeEventListener("visibilitychange", alVolver);
    };
  }, [Usuario?.id, Usuario?.destino, Usuario?.sedeID]);

const abrirListadoLecturas = async (tipo) => {
  setModalLecturas(tipo);
  setCargandoLecturas(true);
  setErrorLecturas("");

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASEURL}expedientes/resumenLecturasDependencia`,
      {},
      {
        withCredentials: true,
      }
    );

    console.log("RESUMEN EXPEDIENTES RECIBIDO:", data);

    if (!data || data.ok === false) {
      throw new Error(
        data?.message || "No se pudo obtener el resumen de expedientes"
      );
    }

    setResumenLecturas(data);
    setErrorLecturas("");

  } catch (error) {
    console.error("ERROR RESUMEN EXPEDIENTES:", {
      url: `${process.env.REACT_APP_BASEURL}expedientes/resumenLecturasDependencia`,
      status: error.response?.status,
      respuesta: error.response?.data,
      mensaje: error.message,
    });

    setErrorLecturas(
      error.response?.data?.message ||
      error.response?.data?.mensaje ||
      error.message ||
      `Error ${error.response?.status || "de conexión"} al consultar expedientes`
    );

    setResumenLecturas(null);

  } finally {
    setCargandoLecturas(false);
  }
};

const irAlExpedienteDesdeLecturas = async (item) => {
  const expediente = item?.Expediente?.[0];

  const numero =
    expediente?.nroExpediente ??
    expediente?.numeroExpediente ??
    expediente?.id;

  const movimientoID =
    item?.movimientoID ??
    item?.Movimientos?.[0]?.id;

  if (numero == null || !movimientoID) {
    setErrorLecturas(
      "No se pudo identificar el expediente o su último movimiento."
    );
    return;
  }

  // Cerramos el listado y abrimos el expediente.
  // El registro se realizará en ConsultaExpediente,
  // después de verificar que se pudo cargar.
  setModalLecturas(null);

  navitate(
    `/consultaExpediente?nroExpediente=${encodeURIComponent(numero)}&movimientoLecturaID=${encodeURIComponent(movimientoID)}`
  );
};
  if (cargandoUsuario) {
    return null;
  }

  if (!Usuario || !Usuario.id) {
    return (
      <div style={{ padding: 30, textAlign: "center" }}>
        <h3>No se pudo cargar el usuario</h3>
        <p>{errorUsuario || "No se encontró una sesión válida."}</p>
        <button onClick={() => logueaUsuario()}>Reintentar</button>
        <button onClick={() => navitate("/")} style={{ marginLeft: 12 }}>Volver al ingreso</button>
      </div>
    );
  }

  // Funciones de navegación
  const volver = async () => {
    try {
      await axios.post("/expedientes/logout");

      LogueMovimientos(Usuario, "Cierra Sesion SIGEDI");

   /*   cookies.remove("usuario", { path: "/" });
      localStorage.clear();
*/
      navitate("/");
      //         console.log("Me cerre")
    } catch (error) {
      //         console.log("Error cerrando sesión:", error);
    }
  };

  const sacarExpediente = () => navitate('/sacaExpediente');
  const recibirExpediente = () => navitate('/recibeExpediente');
  const consultaExpediente = () => navitate('/consultaExpediente');
  const editaUsuarios = () => navitate('/usuarios');
  const inscripcion2024 = () => navitate('/ingreso2024');
  const cadetes = () => navitate('/cadetes');
  const documentos = () => navitate('/documentos');
  const procesos = () => navitate('/procesos');
  const menuCertificados = () => navitate('/Certificados');
  const menuDocentes = () => navitate('/Docentes');
  const calificaciones = () => navitate('/Calificaciones');
  const resoluciones = () => navitate('/Resoluciones');
  const guardiaPrevencion = () => navitate('/GuardiaPrevencion');
  const NCadetes = () => navitate('/NCadetes');
  const Cuerpo = () => navitate('/DivisionCuerpo');
  const Estudio = () => navitate('/DivisionEstudio');
  const UsuariosPermisos = () => navitate('/AdministradorDependencias');
  const Sanidad = () => navitate('/Sanidad');
  const Psicopedagogico = () => navitate('/Psico');
  const Sanciones = () => navitate('/Sanciones');
  const Logistica = () => navitate('/Logistica');
  const DTyD = () => navitate('/DTyD');
  const armeriaPoligono = () => navitate('/ArmeriaPoligono')

  const cerrarNotificacion = () => setVerNotificacion(false);

  function CardBoton({ icono, titulo, descripcion, onClick }) {
    return (
     <div className="tarjetas_principal" onClick={onClick}>
  <div className="tarjeta_icono">{icono}</div>
  <div className="tarjeta_titulo">{titulo}</div>
  <div className="tarjeta_descripcion">{descripcion}</div>
</div>);
  }

  function obtenerIniciales(nombre, apellido) {
    const primeraLetraNombre = nombre?.charAt(0).toUpperCase() || '';
    const primeraLetraApellido = apellido?.charAt(0).toUpperCase() || '';
    return primeraLetraNombre + primeraLetraApellido;
  }

  return (
    <div className='menu_inicio'>
      {intro ? <Bienvenido oculto={() => setIntro(false)} /> : ""}

      <div className='header_principal'>
        <div>
          <img className='escudo_loguin_principal' src='https://www.isepsantafe.edu.ar/images/Escudos%20Isep/escudo_Isep_sin_fondopeque.png' alt="Escudo" />
          <span className='texto-gestor'></span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span className='bienvenido'>Bienvenido</span>
          {Number(Usuario?.destino) > 0 && (
            <div className="lecturas-indicadores" aria-label="Expedientes de la dependencia">
              <button
                type="button"
                className="lecturas-indicador lecturas-indicador-total"
                onClick={() => abrirListadoLecturas("todos")}
                title="Ver todos los expedientes de mi dependencia"
                aria-label={`Ver expedientes de la dependencia: ${resumenLecturas?.totalExpedientes ?? "sin datos"}`}
              >
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M3 7h5l2 2h11v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
                  <path d="M3 7V5a2 2 0 0 1 2-2h5l2 2h5" />
                </svg>
                <span>{resumenLecturas?.totalExpedientes ?? "—"}</span>
              </button>
              <button
                type="button"
                className="lecturas-indicador lecturas-indicador-pendientes"
                onClick={() => abrirListadoLecturas("pendientes")}
                title="Ver expedientes que aún no fueron abiertos"
                aria-label={`Ver expedientes sin abrir: ${resumenLecturas?.totalSinAbrir ?? "sin datos"}`}
              >
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M12 3a8 8 0 1 0 8 8" /><path d="M12 7v5l3 2" /><path d="M16 3h5v5" /><path d="M21 3l-5 5" />
                </svg>
                <span>{resumenLecturas?.totalSinAbrir ?? "—"}</span>
              </button>
            </div>
          )}
          <div className="avatar"
            onClick={editaUsuarios}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && editaUsuarios()}
          >
            {/* 👈 PROTEGIDO: Evita romper la app si el objeto aún no cargó completamente */}
            {obtenerIniciales(Usuario?.nombre, Usuario?.apellido)}
          </div>
          {/* 👈 CORREGIDO: 'class' cambiado por 'className' */}
          <button className="boton_salir_principal" onClick={volver}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-log-out-icon lucide-log-out">
              <path d="m16 17 5-5-5-5" />
              <path d="M21 12H9" />
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            </svg> Salir
          </button>

          {comprueboPermisos(Usuario?.funcion, "Notificaciones") && (
            <span className='btn btn-warning boton_avisos' onClick={() => setVerNotificacion(true)}>
              Ver Notificaciones
            </span>
          )}
        </div>
        <div style={{ position: "fixed", top: 10, right: 10 }}>
          {online ? (
            <span style={{ color: "green" }}>🟢</span>
          ) : (
            <span style={{ color: "red", cursor: "pointer" }} onClick={conectarSocket}>🔴</span>
          )}
        </div>
      </div>

      {modalLecturas && (
        <div className="lecturas-overlay" onClick={() => setModalLecturas(null)}>
          <section className="lecturas-modal" role="dialog" aria-modal="true" aria-label="Expedientes de mi dependencia" onClick={(e) => e.stopPropagation()}>
            <div className="lecturas-modal-cabecera">
              <div>
                <h3>{modalLecturas === "pendientes" ? "Expedientes sin abrir" : "Expedientes de mi dependencia"}</h3>
                <small>{modalLecturas === "pendientes" ? "Movimientos pendientes de primera lectura" : "Expedientes actualmente en la dependencia"}</small>
              </div>
              <button type="button" className="lecturas-cerrar" onClick={() => setModalLecturas(null)} aria-label="Cerrar">×</button>
            </div>
            {errorLecturas && <p className="lecturas-error">{errorLecturas}</p>}
            {cargandoLecturas && <p className="lecturas-cargando">Actualizando listado…</p>}
            <div className="lecturas-listado">
              {(modalLecturas === "pendientes" ? resumenLecturas?.ListaSinAbrir : resumenLecturas?.Lista)?.map((item) => {
                const exp = item?.Expediente?.[0] || {};
                const mov = item?.Movimientos?.[0] || {};
                return (
                  <button
                    type="button"
                    key={`${mov.id || item.movimientoID}-${exp.id}`}
                    className="lecturas-fila"
                    onClick={() => irAlExpedienteDesdeLecturas(item)}
                  >
                    <span className="lecturas-fila-principal">
                      <strong>Expediente {exp.nroExpediente ?? exp.numeroExpediente ?? exp.id}</strong>
                      <small>{exp.concepto || exp.caratula || exp.asunto || "Abrir expediente"}</small>
                    </span>
                    <span className={item.pendienteLectura ? "lecturas-estado pendiente" : "lecturas-estado leido"}>
                      {item.pendienteLectura ? "Sin abrir" : "Abierto"}
                    </span>
                  </button>
                );
              })}
              {!cargandoLecturas && !(modalLecturas === "pendientes" ? resumenLecturas?.ListaSinAbrir : resumenLecturas?.Lista)?.length && !errorLecturas && (
                <p className="lecturas-vacio">No hay expedientes en este listado.</p>
              )}
            </div>
          </section>
        </div>
      )}

      <h3 className="titulo-panel">Panel de Control</h3>

      <section className="menu_botones_principal">
        <div 
  className={`contenedor_botones_principal ${Usuario?.destino == 7 ? 'con-sello' : ''}`} 
  style={{ width: "100%", padding: "10px", textAlign: "center" }}
>

          <CardBoton
            icono={<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icono_Ncadetes"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><path d="M16 3.128a4 4 0 0 1 0 7.744" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><circle cx="9" cy="7" r="4" /></svg>}
            titulo="NCadetes"
            descripcion="Gestión de cadetes y personal"
            onClick={NCadetes}
          />

          <CardBoton
            icono={<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" width="35" height="35" stroke="currentColor" className='icono_Sanciones'><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z" /></svg>}
            titulo="Sanciones"
            descripcion="Registro y seguimiento de sanciones"
            onClick={Sanciones}
          />

          {(Usuario?.destino === "40" || Usuario?.destino === "9" || Usuario?.destino === "7" || Usuario?.destino === "1" || Usuario?.destino === "25" || Usuario?.destino === "2" || comprueboPermisos(Usuario?.funcion, "Veo Procesos")) && (
            <CardBoton
              icono={<svg className='icono_procesos' xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" /><path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" /></svg>}
              titulo="Procesos"
              descripcion="Etapas de ingresos"
              onClick={procesos}
            />
          )}

          {((Number(Usuario?.destino) >= 10 && Number(Usuario?.destino) < 29) || Usuario?.destino === "7" || Usuario?.destino === "45" || Usuario?.destino === "1" || comprueboPermisos(Usuario?.funcion, "Gestion Horas Docentes")) && (
            <CardBoton
              icono={<svg className='icono_Docentes' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width="35" height="35" ><path strokeLinecap="round" strokeLinejoin="round" d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5" /></svg>}
              titulo="Docentes"
              descripcion="Administración del cuerpo docente "
              onClick={menuDocentes}
            />
          )}

          {comprueboPermisos(Usuario?.funcion, "Sanidad") && (
            <CardBoton
              icono={<svg className='icono_Sanidad' xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M8.5 1.5a.5.5 0 1 0-1 0v5.243L7 7.1V4.72C7 3.77 6.23 3 5.28 3c-.524 0-1.023.27-1.443.592-.431.332-.847.773-1.216 1.229-.736.908-1.347 1.946-1.58 2.48-.176.405-.393 1.16-.556 2.011-.165.857-.283 1.857-.241 2.759.04.867.233 1.79.838 2.33.67.6 1.622.556 2.741-.004l1.795-.897A2.5 2.5 0 0 0 7 11.264V10.5a.5.5 0 0 0-1 0v.764a1.5 1.5 0 0 1-.83 1.342l-1.794.897c-.978.489-1.415.343-1.628.152-.28-.25-.467-.801-.505-1.63-.037-.795.068-1.71.224-2.525.157-.82.357-1.491.491-1.8.19-.438.75-1.4 1.44-2.25.342-.422.703-.799 1.049-1.065.358-.276.639-.385.833-.385a.72.72 0 0 1 .72.72v3.094l-1.79 1.28a.5.5 0 0 0 .58.813L8 7.614l3.21 2.293a.5.5 0 1 0 .58-.814L10 7.814V4.72a.72.72 0 0 1 .72-.72c.194 0 .475.11.833.385.346.266.706.643 1.05 1.066.688.85 1.248 1.811 1.439 2.249.134.309.334.98.491 1.8.156.814.26 1.73.224 2.525-.038.829-.224 1.38-.505 1.63-.213.19-.65.337-1.628-.152l-1.795-.897A1.5 1.5 0 0 1 10 11.264V10.5a.5.5 0 0 0-1 0v.764a2.5 2.5 0 0 0 1.382 2.236l1.795.897c1.12.56 2.07.603 2.741.004.605-.54.798-1.463.838-2.33.042-.902-.076-1.902-.24-2.759-.164-.852-.38-1.606-.558-2.012-.232-.533-.843-1.571-1.579-2.479-.37-.456-.785-.897-1.216-1.229C11.743 3.27 11.244 3 10.72 3 9.77 3 9 3.77 9 4.72V7.1l-.5-.357z" /></svg>}
              titulo="Sanidad"
              descripcion="Reconocimientos médicos de cadetes"
              onClick={Sanidad}
            />
          )}

          {comprueboPermisos(Usuario?.funcion, "Gabinete Psico") && (
            <CardBoton
              icono={<svg className='icono_Psicologia' xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M6 1a2 2 0 0 1 4 0v1h1.5A1.5 1.5 0 0 1 13 3.5V5h1a2 2 0 1 1 0 4h-1v1.5A1.5 1.5 0 0 1 11.5 12H10v1a2 2 0 1 1-4 0v-1H4.5A1.5 1.5 0 0 1 3 10.5V9H2a2 2 0 1 1 0-4h1V3.5A1.5 1.5 0 0 1 4.5 2H6V1zm1 1v1.5a.5.5 0 0 1-.5.5H4.5a.5.5 0 0 0-.5.5V6h2a1 1 0 1 1 0 2H4v2.5a.5.5 0 0 0 .5.5H6.5a.5.5 0 0 1 .5.5V13a1 1 0 1 0 2 0v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5V8h-2a1 1 0 1 1 0-2h2V4.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1-.5-.5V2a1 1 0 0 0-2 0z" /></svg>}
              titulo="Gabinete Psicopedagógico"
              descripcion="Area del Gabinete de cadetes"
              onClick={Psicopedagogico}
            />
          )}

          {(Usuario?.destino === "10" || Usuario?.destino === "7" || Usuario?.destino === "1" || Usuario?.destino === "39" || comprueboPermisos(Usuario?.funcion, "Titulos") || comprueboPermisos(Usuario?.funcion, "Certificados")) && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icono_Certificados"><path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" /><circle cx="12" cy="8" r="6" /></svg>}
              titulo="Certificados"
              descripcion="Emisión y control de Certificados"
              onClick={menuCertificados}
            />
          )}

          {Number(Usuario?.destino) > 0 && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" className='icono_Expedientes' viewBox="0 0 16 16"><path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v.64c.57.265.94.876.856 1.546l-.64 5.124A2.5 2.5 0 0 1 12.733 15H3.266a2.5 2.5 0 0 1-2.481-2.19l-.64-5.124A1.5 1.5 0 0 1 1 6.14zM2 6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3H2.5a.5.5 0 0 0-.5.5zm-.367 1a.5.5 0 0 0-.496.562l.64 5.124A1.5 1.5 0 0 0 3.266 14h9.468a1.5 1.5 0 0 0 1.489-1.314l.64-5.124A.5.5 0 0 0 14.367 7z" /></svg>}
              titulo="Expedientes"
              descripcion="Creación y movimientos"
              onClick={consultaExpediente}
            />
          )}

          {(Usuario?.destino === "7" || Usuario?.destino === "1" || comprueboPermisos(Usuario?.funcion, "Jefe de Servicio")) && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="35" height="35" strokeWidth="1.5" stroke="currentColor" className='icono_Guardia'><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m0-10.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.75c0 5.592 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.57-.598-3.75h-.152c-3.196 0-6.1-1.25-8.25-3.286Zm0 13.036h.008v.008H12v-.008Z" /></svg>}
              titulo="Guardia de Prevención"
              descripcion="Guardias, pases y listados"
              onClick={guardiaPrevencion}
            />
          )}

          {(Usuario?.destino === "7" || comprueboPermisos(Usuario?.funcion, "Cuerpo")) && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="35" height="35" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className='icono_Cuerpo'><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Zm0 3h.008v.008h-.008v-.008Z" /></svg>}
              titulo="Cuerpo"
              descripcion="Gestión de compañias y listados"
              onClick={Cuerpo}
            />
          )}

          {(Usuario?.destino === "7" || Usuario?.destino === "1" || comprueboPermisos(Usuario?.funcion, "Estudio")) && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="35" height="35" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className='icono_Estudio'><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" /></svg>}
              titulo="Estudio"
              descripcion="Control de aulas y listados"
              onClick={Estudio}
            />
          )}

          {(Usuario?.destino === "7" || Usuario?.destino === "1" || comprueboPermisos(Usuario?.funcion, "Gestion de Calificaciones")) && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="35" height="35" strokeWidth="1.5" stroke="currentColor" className='icono_Calificaciones'><path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" /></svg>}
              titulo="Gestion de Mi ISeP"
              descripcion="Instancias, Alumnos y Usuarios de Mi ISeP"
              onClick={calificaciones}
            />
          )}

          {(Usuario?.destino === "8" || Usuario?.destino === "7" || comprueboPermisos(Usuario?.funcion, "Logistica")) && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="35" height="35" strokeWidth="1.5" stroke="currentColor" className='icono_Logistica'><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" /></svg>}
              titulo="Logistica"
              descripcion="Registros de internos y presentes"
              onClick={Logistica}
            />
          )}

          {(devuelveEscuela() === "7" || devuelveEscuela() === "25" || devuelveEscuela() === "26" || devuelveEscuela() <= "27" || devuelveEscuela() === "28" || devuelveEscuela() === "1" || comprueboPermisos(Usuario?.funcion, "Resoluciones")) && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icono_Resoluciones"><path d="M10 18v-7" /><path d="M11.12 2.198a2 2 0 0 1 1.76.006l7.866 3.847c.476.233.31.949-.22.949H3.474c-.53 0-.695-.716-.22-.949z" /><path d="M14 18v-7" /><path d="M18 18v-7" /><path d="M3 22h18" /><path d="M6 18v-7" /></svg>}
              titulo="Resoluciones"
              descripcion="Carga y publicación"
              onClick={resoluciones}
            />
          )}

          {comprueboPermisos(Usuario?.funcion, "DG") && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icono_Documentos"><rect width="16" height="13" x="6" y="4" rx="2" /><path d="m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7" /><path d="M2 8v11c0 1.1.9 2 2 2h14" /></svg>}
              titulo="Documentos D.G"
              descripcion="Documentos Dirección General"
              onClick={documentos}
            />
          )}

          {(comprueboPermisos(Usuario?.funcion, "DTyD") && Usuario?.destino === "7") && (
            <CardBoton
              icono={<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icono_Documentos"><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon></svg>}
              titulo="DTyD"
              descripcion="Tecnología y Desarrollo"
              onClick={DTyD}
            />
          )}
          {( Usuario?.destino === "7" || comprueboPermisos(Usuario?.funcion, "Edicion de Usuarios y Permisos")) && (
            <CardBoton
              icono={<svg className='icono_permisos' xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" /><path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" /></svg>}
              titulo="Destinos y Dependencias"
              descripcion="Organigramas y relaciones"
              onClick={UsuariosPermisos}
            />
          )}

          {(comprueboPermisos(Usuario?.funcion, "Armeria") || Usuario?.destino === "7") && (
            <CardBoton
              icono={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  width="35"
                  height="35"
                  strokeWidth="1.5"
                  stroke="#7CB342"
                  className="icono_Guardia"
                >
                  <circle cx="12" cy="12" r="8.5" strokeLinecap="round" />
                  <circle cx="12" cy="12" r="5" strokeLinecap="round" />
                  <circle cx="12" cy="12" r="1.8" strokeLinecap="round" />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 3.5V1.5M12 22.5v-2M3.5 12h-2M22.5 12h-2"
                  />
                </svg>
              }
              titulo="Armería y Polígono"
              descripcion="Planillas y Armamento"
              onClick={armeriaPoligono}
            />
          )}
        </div>

        {comprueboPermisos(Usuario?.funcion, "Notificaciones") && (
          <Notificaciones mostrame={verNotificacion} cierro={cerrarNotificacion} />
        )}
      </section>

      <div style={{ width: "100%", textAlign: "center" }}>
        <FooterCorp />
      </div>
    </div>
  );
}

export default Main;